import { getEnv } from 'config';
import { EnvironmentConfig } from 'types';
import { PathVariableMapping, replacePathVariables } from 'utils/http';

/**
 * Creates an endpoint for a service defined by the `serviceConfig`.
 *
 * Endpoint URLs can only be constructed after the library's `configure` function
 * is called, so having a function to create the URLs delays reading environment
 * variables set by `configure` until runtime as opposed to import-time.
 */
export const createGetEndpoint =
  <TEndpointName extends string>(
    serviceConfig: EnvironmentConfig,
    pathMapping: Record<TEndpointName, string>,
  ) =>
  (name: TEndpointName, pathVariables?: PathVariableMapping): string => {
    const baseUrl = getEnv(serviceConfig);
    const path = pathMapping[name];

    const endpoint = baseUrl + path;

    return !pathVariables
      ? endpoint
      : replacePathVariables(endpoint, pathVariables);
  };
